import template from './trip-checkout-book-or-hold.html';
import tripEvents from './../../config/events.constant';
import tripStatuses from './../../trip-statuses';
import paymentsConst from '../../../../constants/payments.constant';

const DIRECTIVE_NAME = TripCheckoutBookOrHold.DIRECTIVE_NAME = 'ktTripCheckoutBookOrHold';
export default function TripCheckoutBookOrHold() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        transclude: true,
        controller: TripCheckoutBookOrHoldController,
        controllerAs: '$ctrl',
        scope: {
            isBook: `=${DIRECTIVE_NAME}IsBook`,
            isHold: `=${DIRECTIVE_NAME}IsHold`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            tripData: `=${DIRECTIVE_NAME}TripData`,
            actionData: `=${DIRECTIVE_NAME}ActionData`,
            checkoutForm: `=${DIRECTIVE_NAME}CheckoutForm`,
            showApproverMessage: `=${DIRECTIVE_NAME}ShowApproverMessage`,
            doesUserAgreeWithUclTerms: `=${DIRECTIVE_NAME}DoesUserAgreeWithUclTerms`,
            travelFusionCardValidation: `=${DIRECTIVE_NAME}TravelFusionCardValidation`,
        },
        link: {
            pre: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
        },
    };
}

const BOOK = 'Book';
const HOLD = 'Hold';

const MESSAGE_INCOMPLETE_TRAVELLER = 'You need to complete traveller information before you can book or hold a trip';
const NO_ITEMS_TO_BE_HELD = `
    Only 1 Rail booking can be held at a time.
    If you wish to hold this trip then please
    either confirm or cancel your other held booking
`;
const HELD_ITEM_ALREADY_EXISTS_TITLE = 'There are no items in this trip that can be held';

export function TripCheckoutBookOrHoldController(
    $scope,
    $state,
    $rootScope,
    $stateParams,
    $timeout,
    tripFactory,
    tripUtils,
    tripOptionsService,
    userService,
    tripBookingModal,
    l10nService,
    railAmendmentService,
    tripDetailsService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isCancelButtonVisible,
        isCheckoutBookOrHoldButtonsVisible,
        isTermsAndConditionsTooltipEnabled,
        isConfirmButtonDisabled,
        MESSAGE_INCOMPLETE_TRAVELLER,
        l10nService,
    });

    function $onInit() {
        initializeEventWatcher();
        initializeScope($scope);
    }
    function isConfirmButtonDisabled() {
        return !!($scope.confirmBookDisabled
            || vm.tripData.TermsAndConditionsConfiguration
            && !vm.doesUserAgreeWithUclTerms);
    }

    function isTermsAndConditionsTooltipEnabled() {
        return !!(vm.tripData.TermsAndConditionsConfiguration
            && vm.tripData.TermsAndConditionsConfiguration.Sections
            && !vm.doesUserAgreeWithUclTerms);
    }

    function isCheckoutBookOrHoldButtonsVisible() {
        if (vm.tripDetails.IsOfflineTrip && ([tripStatuses.PENDING_CONFIRMATION, tripStatuses.CONFIRMED].includes(vm.tripDetails.Status))) {
            return false;
        }
        return !vm.isBook && !vm.isHold;
    }

    function isCancelButtonVisible() {
        if (vm.tripDetails.IsOfflineTrip) {
            return false;
        }
        return vm.isBook && !vm.showApproverMessage || vm.isHold;
    }

    function initializeEventWatcher() {
        $scope.$on(tripEvents.TRIP_CHECKOUT_BUTTON_START, (event, arg) => {
            const functionToCall = $scope[`checkout${arg}`];
            if (!functionToCall) {
                return;
            }
            functionToCall();
        });

        $scope.$on(tripEvents.TRIP_REFRESH, function() {
            const type = vm.isBook
                ? tripEvents.TRIP_START_BOOK
                : tripEvents.TRIP_START_HOLD;
            $rootScope.$broadcast(type);
        });
    }

    function initializeScope(scope) {
        scope.confirmBookDisabled = false;

        scope.tooltipErrorContent = tripFactory.getBookErrorTooltipContent(
            vm.tripDetails.CanBeBookedStatus,
            userService.isUSRegion()
        );

        vm.isBook = false;
        vm.isHold = false;

        scope.errors = {
            show: false,
            type: 4,
        };

        scope.getHoldButtonTitle = function() {
            if (!scope.isTravellersCompleted()) {
                return l10nService.localize(MESSAGE_INCOMPLETE_TRAVELLER);
            } else if (vm.tripDetails.Rails.length && vm.tripDetails.HeldTripIdWithTrainlineItem) {
                return l10nService.localize(NO_ITEMS_TO_BE_HELD) + vm.tripDetails.HeldTripIdWithTrainlineItem;
            } else if (!vm.tripDetails.CanBeHeld) {
                return l10nService.localize(HELD_ITEM_ALREADY_EXISTS_TITLE);
            }

            return '';
        };
        scope.canBook = function() {
            return userService.isBooker()
                && scope.isTravellersCompleted()
                && (vm.tripDetails.CanBeBookedStatus === 0)
                && !vm.tripDetails.Locked
                && (isQuoteOrHeld() || isInRebookMode());
        };

        function isInRebookMode() {
            return !!$stateParams.rebook;
        }
        scope.canHold = function() {
            return userService.isTripHolder()
                && scope.isTravellersCompleted()
                && vm.tripDetails.CanBeHeld
                && !vm.tripDetails.Locked
                && vm.tripDetails.Status === tripStatuses.QUOTE;
        };

        scope.isTravellersCompleted = function() {
            return _.every(vm.tripDetails.Travelers, function(group) {
                return _.every(group, function(traveller) {
                    return traveller.IsCompleted;
                });
            });
        };

        scope.checkBookTripAvailability = function() {

            /**
             * Alternative for ng-disabled for "Book" btn
             * Because ng-disabled reject hover event which needed for tooltip
             */

            const isTripAvailabilityAllowed = userService.isBooker()
                && scope.isTravellersCompleted()
                && (vm.tripDetails.CanBeBookedStatus === 0)
                && !vm.tripDetails.Locked
                && isQuoteOrHeld();
            if (!isTripAvailabilityAllowed) {
                return false;
            }
            $rootScope.$broadcast(tripEvents.TRIP_CHECK_AVAILABILITY, BOOK);
        };
        scope.checkHoldTripAvailability = function() {

            /**
             * Alternative for ng-disabled for "Book" btn
             * Because ng-disabled reject hover event which needed for tooltip
             */

            const isTripAvailabilityAllowed = userService.isTripHolder()
                && scope.isTravellersCompleted()
                && (vm.tripDetails.CanBeBookedStatus === 0)
                && !vm.tripDetails.Locked
                && isQuoteOrHeld();
            if (!isTripAvailabilityAllowed) {
                return false;
            }
            $rootScope.$broadcast(tripEvents.TRIP_CHECK_AVAILABILITY, HOLD);
        };

        function isQuoteOrHeld() {
            return [tripStatuses.QUOTE, tripStatuses.HELD].includes(vm.tripDetails.Status);
        }

        scope.checkoutBook = function() {
            vm.isBook = true;
            $rootScope.$broadcast(tripEvents.TRIP_START_BOOK);
        };

        scope.checkoutHold = function() {
            $rootScope.$broadcast(tripEvents.TRIP_START_HOLD);
            vm.isHold = true;
        };

        scope.confirmHold = function() {
            if (vm.checkoutForm.$valid
                && tripFactory.validateAllocation([vm.tripDetails.Hotels, vm.tripDetails.Cars])) {
                scope.tripDetails = vm.tripDetails;
                tripFactory.actionTrip(tripOptionsService.TRIP_ACTION.Hold, vm.actionData, vm.tripDetails, vm.tripData).then(
                    function(response) {
                        tripBookingModal.openHoldModal(response, scope);
                    }
                );
            }
        };

        scope.confirmBook = function() {
            $rootScope.$broadcast(tripEvents.TRIP_CHECKOUT_SUBMIT_TRY);

            function isConfirmBookAllowed() {
                const {checkoutForm} = vm;

                if (!checkoutForm.$valid) {
                    return false;
                }
                if (vm.tripData.PaymentSystem !== paymentsConst.PaymentSystem.Adflex) {
                    return true;
                }

                return (checkoutForm.ccForm && checkoutForm.ccForm.cvv) ? !!checkoutForm.ccForm.cvv.$modelValue : true;
            }

            function getTripActionId() {
                const {Confirm, Amend} = tripOptionsService.TRIP_ACTION;
                return $stateParams.rebook ? Amend : Confirm;
            }

            /**
             * We need to wait until broadcast will make changes to form
             * Timeout fixes this problem
             */

            $timeout(function() {
                if (isConfirmBookAllowed()) {
                    const creditCard = vm.actionData.getCreditCard();
                    if (creditCard && vm.tripData.PaymentSystem !== paymentsConst.PaymentSystem.Adflex && !creditCard.enterAfterApproval) {

                        if (creditCard && !creditCard.Token) {
                            const cardData = tripFactory.getCardData(creditCard, false);
                            Spreedly.tokenizeCreditCard(cardData);

                            return;
                        }

                        const pendingApproval = vm.tripData.ApprovalSettings.IsApprovalRequired && !vm.tripData.IsApproved;
                        if (creditCard.isFullForm && creditCard.Token && !pendingApproval) {
                            Spreedly.recache();

                            return;
                        }
                    }

                    tripFactory.actionTrip(getTripActionId(), vm.actionData, vm.tripDetails, vm.tripData)
                        .then(function(response) {
                            if (!tripUtils.openCardValidationUrls(vm.tripDetails.Id, response)) {
                                if (isInRebookMode()) {
                                    railAmendmentService.showAmendmentSuccessPopup(vm.tripDetails, vm.tripData)
                                        .then(() => tripDetailsService.navigateToTripDetails(vm.tripDetails.Id));
                                } else {
                                    tripBookingModal.openBookModal(response, scope, vm.tripDetails.Id, vm.tripDetails);
                                    scope.confirmBookDisabled = true;
                                }
                            }
                        })
                        .catch((error) => {
                            scope.confirmBookDisabled = /5\d{2}/.test(error.status);
                            if (scope.confirmBookDisabled) {
                                vm.tripDetails.Locked = true;
                            }
                        })
                        .finally(() => {
                            railAmendmentService.unsubscribeFromRebookMode();
                        });
                }
            }, 0);
        };

        scope.cancelProcess = function() {
            vm.checkoutForm.$setPristine();
            vm.isBook = false;
            vm.isHold = false;
            $rootScope.$broadcast(tripEvents.TRIP_CANCEL_CHECKOUT_PROCESS);
        };

        /**
         * Show booking success popup if returned from TravelFusion card verification
         */
        if (_.isObject(vm.travelFusionCardValidation)) {
            tripBookingModal.openBookModal(vm.travelFusionCardValidation, scope, vm.tripDetails.Id, vm.tripData);
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-checkout-book-or-hold/trip-checkout-book-or-hold-component.js